import styled from 'styled-components';
var Switch = styled.div.withConfig({
  displayName: "Switchstyles__Switch",
  componentId: "sc-5aolx1-0"
})(["position:relative;display:inline-block;"]);
var SwitchInput = styled.input.withConfig({
  displayName: "Switchstyles__SwitchInput",
  componentId: "sc-5aolx1-1"
})(["border:0;padding:0;width:1px;height:1px;position:absolute;overflow:hidden;white-space:nowrap;clip-path:inset(50%);&:checked + span label:after{left:calc(100% - 2px);transform:translateX(-100%);}&:checked + span:before{opacity:0.7;}&:checked + span:after{opacity:1;}&:focus + span{outline:1px auto Highlight;outline:1px auto -webkit-focus-ring-color;}"]);
var ToggleWrapper = styled.span.withConfig({
  displayName: "Switchstyles__ToggleWrapper",
  componentId: "sc-5aolx1-2"
})(["padding:3px;display:flex;justify-content:center;font-size:", ";font-weight:", ";&:before{opacity:1;content:'cm';display:inline-block;padding-right:", ";}&:after{opacity:0.7;content:'Inches';display:inline-block;padding-left:", ";}"], function (props) {
  return props.theme.font.size['body-1'];
}, function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.size.spacing.base;
}, function (props) {
  return props.theme.size.spacing.base;
});
var Toggle = styled.label.withConfig({
  displayName: "Switchstyles__Toggle",
  componentId: "sc-5aolx1-3"
})(["width:40px;height:20px;border-radius:20px;position:relative;display:inline-block;background:#000;cursor:pointer;&:after{width:16px;height:16px;border-radius:16px;content:'';position:absolute;top:2px;left:2px;background:", ";transition:0.2s;}"], function (props) {
  return props.theme.color.monochrome.white;
});
export { Switch, SwitchInput, ToggleWrapper, Toggle };